import { render } from "./CustomTimerBanner.vue?vue&type=template&id=0c6271e6"
import script from "./CustomTimerBanner.vue?vue&type=script&lang=js"
export * from "./CustomTimerBanner.vue?vue&type=script&lang=js"

import "./CustomTimerBanner.vue?vue&type=style&index=0&id=0c6271e6&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__